export const investorCrmPipelineArticle = {
  title: 'Investor CRM: Pipeline Board',
  slug: 'investor-crm-pipeline',
  content: `Investor CRM: Pipeline Board

Use the Pipeline tab to track investor stages.

1) Stage columns
- Stages include Prospecting, Warm Intro, First Meeting, Diligence, Term Sheet, Committed, Closed Won, and Closed Lost.

2) Drag and drop
- Drag investor cards between stages to update status.

3) Open investor details
- Click a card to open the investor drawer.
- Update notes, stage, and activity logs from the drawer.
`,
};
